import React from "react";
import { FaInstagram, FaEnvelope } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const emailAddress = "webapp.naim@gmail.com";
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="w-full py-16 border-t border-slate-200/60 font-sans bg-transparent">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-10 md:gap-0">

        {/* Left: Brand & Desc */}
        <div className="flex flex-col items-center md:items-start gap-4 text-center md:text-left">
          <h3 className="font-sans uppercase tracking-[0.2em] text-xs sm:text-sm text-slate-900 cursor-pointer select-none">
            {t("brand.name")}
          </h3>
          {/* <p className="text-slate-500 text-sm font-light max-w-xs leading-relaxed">
            {t("footer.description")}
          </p> */}
        </div>

        {/* Center: Socials (Minimal) */}
        <div className="flex items-center gap-8">
          <a
            href={`mailto:${emailAddress}`}
            className="text-slate-400 hover:text-slate-900 transition-all duration-300 transform hover:scale-110"
            aria-label="Email"
          >
            <FaEnvelope size={18} />
          </a>
          <a
            href="https://www.instagram.com/naif92_naim/?hl=it"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-400 hover:text-slate-900 transition-all duration-300 transform hover:scale-110"
            aria-label="Instagram"
          >
            <FaInstagram size={20} />
          </a>
        </div>

        {/* Right: Copyright & Legal */}
        <div className="flex flex-col items-center md:items-end gap-2 text-xs text-slate-400 font-light tracking-wide uppercase">
          <p>{t("footer.rights", { year })}</p>
          <a href="#cookieBanner" className="hover:text-slate-800 transition-colors border-b border-transparent hover:border-slate-800">
            {t("footer.cookies")}
          </a>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
